var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"make_payment_wrapper"},[_c('div',{staticClass:"payment-popup-button",class:{'disabled': _vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",[_vm._v("Оплатить")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }